import React, {lazy, Suspense} from 'react';
import './App.scss';
import { Route, Switch, withRouter, useRouteMatch } from "react-router-dom";
import Header  from "./Header"
import Startpage from "./Startpage"
import NotFound from "./NotFound"
import * as Constants from "./helper/Constants"
import {useState, useEffect} from "react";
import UrlHelper from "./helper/UrlHelper";

const AllCategoriesView = lazy(() => import("./AllCategoriesView"));
const Project = lazy(() => import("./Project"));
const AllProjectsOfSpecificCategory = lazy(() => import("./AllProjectsOfSpecificCategory"));
const ProjectList = lazy(() => import("./ProjectList"));
const Contact = lazy(() => import("./Contact"));

const MainApplication = (props) => {
    const [numRouteUpdates, setNumRouteUpdates] = useState(0);
    let { path, url } = useRouteMatch();

    useEffect(() => {
        props.history.listen((location, action) => {
            setNumRouteUpdates(numRouteUpdates + 1);
        })
    }, [])

    return (
        <>
            <div className="content">
                <Header/>
                <div className="main-content fadeIn-1s">
                    <Switch>
                        <Route exact path={path} component={Startpage} />
                        <Suspense fallback={<></>}>
                            <Route exact path={UrlHelper.join(path, Constants.LINK_ALL_CATEGORIES_RELATIVE)} component={AllCategoriesView} />
                            {/*<Route exact path={UrlHelper.join(path, Constants.LINK_WERKVERZEICHNIS_RELATIVE)} component={ProjectList} />*/}
                            <Route exact path={UrlHelper.join(path, Constants.LINK_CONTACT_RELATIVE)} component={Contact} />
                            <Route exact path={UrlHelper.join(path, Constants.LINK_CATEGORY_OVERVIEW)} key={Date.now()} component={AllProjectsOfSpecificCategory}/>
                            <Route exaxt path={UrlHelper.join(path, Constants.LINK_SINGLE_PROJECT_VIEW)} component={Project}/>
                            <Route exaxt path={UrlHelper.join(path, Constants.LINK_SINGLE_PROJECT_VIEW_FROM_WERKVERZEICHNIS)} component={Project}/>
                        </Suspense >
                        <Route component={NotFound}/>
                    </Switch>
                </div>
            </div>

        </>
    );
}

export default withRouter(MainApplication);
